import React from 'react'

import { NavLink } from 'react-router-dom';

import logo from '../images/festivality-logo-bird.png'
import userpic from '../images/ava.jpg'

// import campaigns from '../images/campaigns.svg'

const CampaignsSVG = () => (
  <svg width="30px" height="50%" fill="#9fa8da" style={{transform: "translateX(4px)"}} viewBox="0 0 120 90" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M 92.4 30.2687L 88.3 30.2687L 88.3 1.96875C 88.3 1.16875 87.8 0.46875 87.1 0.16875C 86.4 -0.13125 85.5 -0.0312508 85 0.468749C 72.2 11.6687 55.8 17.8688 38.9 17.8688L 18.9 17.8688C 8.5 17.8688 0 26.3687 0 36.7687L 0 38.1688C 0 48.5688 8.5 57.0688 18.9 57.0688C 19.1 57.0688 19.3 57.0688 19.5 56.9688L 26.5 56.9688L 26.5 79.9688C 26.5 82.4688 27.5 84.7687 29.2 86.5687C 30.9 88.2687 33.3 89.2687 35.7 89.2687C 35.7 89.2687 35.7 89.2687 35.8 89.2687C 40.9 89.2687 45.1 85.0687 45.1 79.8687L 45.1 62.9688C 45.1 61.8688 44.2 60.9688 43.1 60.9688C 42 60.9688 41.1 61.8688 41.1 62.9688L 41.1 79.8687C 41.1 82.8687 38.7 85.2687 35.8 85.2687C 34.4 85.2687 33.1 84.7687 32.1 83.7687C 31.1 82.7687 30.5 81.4688 30.5 79.9688L 30.5 56.9688L 39.4 56.9688C 56.1 56.9688 72.3 62.8687 85 73.5687C 85.4 73.8687 85.8 74.0687 86.3 74.0687C 86.6 74.0687 86.9 73.9687 87.1 73.8687C 87.8 73.5687 88.3 72.8687 88.3 72.0687L 88.3 43.6688L 92.5 43.6688C 96.2 43.6688 99.2 40.6688 99.2 36.9688C 99.2 35.1688 98.5 33.4687 97.2 32.2687C 95.9 30.9687 94.2 30.2687 92.4 30.2687ZM 4 38.1688L 4 36.7687C 4 29.2687 9.6 22.9688 16.9 21.9688L 16.9 52.8687C 9.6 51.9687 4 45.6688 4 38.1688ZM 39.4 52.9688L 20.9 52.9688L 20.9 21.8688L 38.9 21.8688C 55.4 21.8688 71.4 16.3687 84.3 6.26875L 84.3 32.2687L 84.3 41.6688L 84.3 67.8687C 71.4 58.2687 55.6 52.9688 39.4 52.9688ZM 92.4 39.6688L 88.3 39.6688L 88.3 34.2687L 92.5 34.2687C 93.2 34.2687 93.9 34.5688 94.4 35.0688C 94.9 35.5688 95.2 36.2688 95.2 36.9688C 95.1 38.4688 93.9 39.6688 92.4 39.6688Z"/>
  </svg>  
)

const FansSVG = () => (
  <svg width="18" height="63" fill="#9fa8da" viewBox="0 0 43 63" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M 42.01 40.365L 42.01 12.228C 42.01 8.792 39.319 5.999 36.01 5.999C 32.701 5.999 30.01 8.792 30.01 12.228L 30.01 15.039C 28.947 14.086 27.549 13.5 26.01 13.5C 23.92 13.5 22.08 14.574 21.005 16.199C 19.931 14.574 18.09 13.5 16 13.5C 14.462 13.5 13.062 14.086 12 15.039L 12 6C 12 2.691 9.309 -8.23975e-07 6 -8.23975e-07C 2.691 -8.23975e-07 9.30786e-07 2.691 9.30786e-07 6L 9.30786e-07 35.221L 9.30786e-07 36.055L 9.30786e-07 43.043C 0.0420009 43.244 0.0749991 43.449 0.0969991 43.654C 0.102999 43.662 0.105999 43.67 0.110999 43.675C 1.196 54.304 10.162 62.623 21.026 62.623C 32.62 62.623 42.052 53.15 42.052 41.506C 42.051 41.121 42.032 40.744 42.01 40.365ZM 22.011 19.499C 22.011 17.292 23.805 15.499 26.011 15.499C 28.218 15.499 30.011 17.292 30.011 19.499L 30.011 29.956L 30.011 31.888C 30.011 34.093 28.218 35.888 26.011 35.888C 25.224 35.888 24.491 35.65 23.872 35.255C 23.491 34.4 22.919 33.646 22.206 33.056C 22.091 32.685 22.011 32.296 22.011 31.888L 22.011 19.499ZM 16 15.499C 18.205 15.499 20 17.292 20 19.499L 20 31.888C 20 31.894 19.998 31.902 19.998 31.908C 19.484 31.765 18.946 31.683 18.389 31.683L 12 31.683L 12 19.499C 12 17.292 13.794 15.499 16 15.499ZM 6 1.999C 8.205 1.999 10 3.792 10 5.999L 10 19.499L 10 31.683L 6 31.683C 4.462 31.683 3.062 32.269 2 33.222L 2 5.999C 2 3.792 3.794 1.999 6 1.999ZM 21.026 60.623C 10.746 60.623 2.364 52.389 2.024 42.146C 2.014 42.123 2.009 42.097 2.001 42.074L 2.001 38.222C 2.014 38.202 2.022 38.181 2.035 38.161C 2.015 38.003 2.001 37.845 2.001 37.682C 2.001 35.475 3.795 33.682 6.001 33.682L 18.39 33.682C 20.595 33.682 22.39 35.475 22.39 37.682C 22.39 39.887 20.595 41.682 18.39 41.682L 14.279 41.682L 14.279 43.682L 18.39 43.682C 21.699 43.682 24.39 40.991 24.39 37.682C 24.39 37.67 24.388 37.661 24.388 37.651C 24.904 37.801 25.447 37.887 26.011 37.887C 29.32 37.887 32.011 35.196 32.011 31.887L 32.011 29.924L 32.011 19.499L 32.011 12.228C 32.011 9.896 33.806 7.999 36.011 7.999C 38.218 7.999 40.011 9.895 40.011 12.228L 40.011 40.171C 40.007 40.179 40.005 40.185 39.999 40.191C 40.005 40.275 40.005 40.361 40.011 40.443L 40.011 42.482C 39.499 52.568 31.192 60.623 21.026 60.623Z"/>
  </svg>
)

const EventsSVG = () => (
  <svg width="88" height="50%" fill="#9fa8da" viewBox="0 0 88 88" xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink">
      <desc>Created using Figma</desc>
      <g id="Canvas" transform="translate(75 149)">
          <g id="Group">
              <use xlinkHref="#path0_fill" transform="translate(-75 -112.279)" id="Compound Path"
              />
              <use xlinkHref="#path1_fill" transform="translate(-44.816 -128.6)" id="Path"
              />
              <use xlinkHref="#path2_fill" transform="translate(-50.416 -149)" id="Compound Path"
              />
              <use xlinkHref="#path3_fill" transform="translate(-26.416 -98.473)" id="Path"
              />
              <use xlinkHref="#path4_fill" transform="translate(-6.316 -104.9)" id="Compound Path"
              />
              <use xlinkHref="#path5_fill" transform="translate(-23.416 -131.9)" id="Compound Path"
              />
              <use xlinkHref="#path6_fill" transform="rotate(-45 -141.658 -9.04)" id="Path"
              />
          </g>
      </g>
      <defs>
          <path id="path0_fill" d="M 1.08354 50.679L 1.48354 50.679L 50.1835 30.279C 50.328 30.212 50.4543 30.1114 50.552 29.9857C 50.6498 29.86 50.7161 29.7127 50.7454 29.5562C 50.7748 29.3997 50.7663 29.2385 50.7208 29.0859C 50.6752 28.9333 50.5939 28.7938 50.4835 28.679L 22.0835 0.279002C 21.9687 0.168662 21.8292 0.0873346 21.6767 0.0417852C 21.5241 -0.00376417 21.3628 -0.0122181 21.2063 0.017127C 21.0498 0.0464721 20.9026 0.112768 20.7769 0.210498C 20.6511 0.308228 20.5506 0.434566 20.4835 0.579001L 0.0835444 49.379C 0.0176568 49.5299 -0.00994675 49.6948 0.00318541 49.8589C 0.0163176 50.023 0.0697788 50.1814 0.158822 50.3199C 0.247865 50.4584 0.369733 50.5728 0.513606 50.6529C 0.657479 50.733 0.818903 50.7763 0.983544 50.779L 1.08354 50.679ZM 25.1835 38.579L 15.2835 42.679L 8.08354 35.479L 12.1835 25.579L 25.1835 38.579ZM 12.9835 23.579L 17.0835 13.679L 37.0835 33.579L 27.1835 37.679L 12.9835 23.579ZM 21.7835 2.679L 48.0835 28.979L 39.0835 32.779L 17.9835 11.679L 21.7835 2.679ZM 7.28354 37.379L 13.3835 43.479L 2.88354 47.879L 7.28354 37.379Z"
          />
          <path id="path1_fill" d="M 1.52588e-06 17.1L 1.4 18.5C 3.8482 16.0212 5.5467 12.9015 6.3 9.5C 7.01987 6.36035 6.91653 3.08798 6 7.62939e-07L 4.1 0.599999C 4.93192 3.35996 5.03527 6.28826 4.4 9.1C 3.71501 12.1274 2.18995 14.9003 1.52588e-06 17.1L 1.52588e-06 17.1Z"
          />
          <path id="path2_fill" d="M 15 10.9L 18.8 6.9L 13.5 5.3L 11.9 1.90735e-07L 7.9 3.8L 2.5 2.5L 3.8 7.9L -7.62939e-07 11.9L 5.3 13.5L 6.9 18.8L 10.9 15L 16.3 16.3L 15 10.9ZM 10.3 12.8L 7.9 15.1L 6.9 11.9L 3.7 10.9L 6 8.5L 5.2 5.2L 8.5 6L 10.9 3.7L 11.9 6.9L 15.1 7.9L 12.8 10.3L 13.6 13.6L 10.3 12.8Z"
          />
          <path id="path3_fill" d="M 9.4 2.37297C 12.2117 1.73769 15.14 1.84104 17.9 2.67297L 18.5 0.772966C 15.412 -0.143565 12.1397 -0.246902 9 0.472967C 5.59846 1.22627 2.47876 2.92477 -7.62939e-07 5.37297L 1.4 6.77297C 3.59972 4.58302 6.37255 3.05796 9.4 2.37297L 9.4 2.37297Z"
          />
          <path id="path4_fill" d="M 13.5 5.3L 11.9 1.52588e-06L 7.9 3.8L 2.5 2.5L 3.8 7.9L 1.52588e-06 11.9L 5.3 13.5L 6.9 18.8L 10.9 15L 16.3 16.3L 15 10.9L 18.8 6.9L 13.5 5.3ZM 13.6 13.6L 10.3 12.8L 7.9 15.1L 6.9 11.9L 3.7 10.9L 6 8.5L 5.2 5.2L 8.5 6L 10.9 3.7L 11.9 6.9L 15.1 7.9L 12.8 10.3L 13.6 13.6Z"
          />
          <path id="path5_fill" d="M 13.5 5.3L 11.9 -3.8147e-07L 7.9 3.8L 2.5 2.5L 3.8 7.9L -7.62939e-07 11.9L 5.3 13.5L 6.9 18.8L 10.9 15L 16.3 16.3L 15 10.9L 18.8 6.9L 13.5 5.3ZM 13.6 13.6L 10.3 12.8L 7.9 15.1L 6.9 11.9L 3.7 10.9L 6 8.5L 5.2 5.3L 8.5 6.1L 10.9 3.8L 11.9 7L 15.1 8L 12.8 10.4L 13.6 13.6Z"
          />
          <path id="path6_fill" d="M 15.8 0L 0 0L 0 2L 15.8 2L 15.8 0Z" />
      </defs>
  </svg>
)


class Menu extends React.Component {
  state = {
    showMenu: false,
  }

  toggleMenu = (ev) => {
    this.setState({ showMenu: !this.state.showMenu });
  }

  showMenu = (ev) => {
    this.setState({ showMenu: true });
  }

  closeMenu = (ev) => {
    this.setState({ showMenu: false });
  }
  
  render() {
    const { className } = this.props;
    const menu__content = this.state.showMenu ? 'menu__content menu--show' : 'menu__content';
    return (
      <div className="menu" onBlur={this.closeMenu} tabIndex="0">
        <div onClick={this.toggleMenu} className="sidebar__profile-link">
          <img className="sidebar__profile-img" src={userpic} alt="Fansifter"/>
        </div>
        <div className={menu__content + ' ' + className} onClick={this.closeMenu}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

const Sidebar = (props) => (
  <div className="sidebar">
    <NavLink className="sidebar__logo" to="/">
      <img className="sidebar__logo-img" src={logo} alt="Fansifter"/>
    </NavLink>
    <div className="sidebar-nav">
      <NavLink className="sidebar-nav__item" 
        activeClassName="sidebar-nav__item--active"
        to="/campaigns"><CampaignsSVG/></NavLink>
      <NavLink className="sidebar-nav__item" 
        activeClassName="sidebar-nav__item--active"
        to="/fans"><FansSVG/></NavLink>
      <NavLink className="sidebar-nav__item" 
        activeClassName="sidebar-nav__item--active"
        to="/events"><EventsSVG/></NavLink>
      {/* <NavLink className="sidebar-nav__item" 
        activeClassName="sidebar-nav__item--active"
        to="/campaigns">Events</NavLink>
      <NavLink className="sidebar-nav__item" 
        activeClassName="sidebar-nav__item--active"
        to="/campaigns">Library</NavLink> */}
    </div>
    <div className="sidebar__profile">
      <Menu className="sidebar-menu">
        <NavLink className="sidebar-menu__item" 
          activeClassName=""
          to="/profile">Profile</NavLink>
        <NavLink className="sidebar-menu__item" 
          activeClassName=""
          to="/profile">Settings</NavLink>
        <div className="sidebar-menu__item" onClick={props.logout}>Log Out</div>
      </Menu>
      {/* <NavLink className="sidebar-nav__item sidebar__profile-link" 
        activeClassName="sidebar-nav__item--active"
        to="/profile">
        <img className="sidebar__profile-img" src={userpic} alt="Fansifter"/>
      </NavLink>
      <button className="logout" onClick={props.logout}>Log Out</button> */}
    </div>
  </div>
)

export default Sidebar


// WEBPACK FOOTER //
// ./src/components/Sidebar.js